//  声明 公共方法
// 获取客户端七牛上传图片uptoken
// import { getQiniuToken } from "@/api/enter";
//
// function getUpToken(token, version) {
//   getQiniuToken(
//     {},
//     {
//       token: token,
//       version: version || "1.0.0",
//       "client-type": "3",
//       "device-imei": "1",
//     }
//   )
//     .then((res) => {
//       console.log(res);
//       return res.data.data.uptoken;
//       // this.uptoken = res.data.data.uptoken;
//     })
//     .catch((err) => {
//       console.log(err);
//     });
// }
// 判断是否大众+ app内
function getIsApp() {
  let ua = navigator.userAgent.toLowerCase();
  if (ua.match(/dazhongplus/i) == "dazhongplus") {
    return true;
  }
  return false;
}
// 上传图片新增了时间目录
function toDouble(val) {
  if (isNaN(val)) return;
  return val < 10 ? "0" + val : val;
}
function fileRandomKey(type = "") {
  let date = new Date();
  return `${date.getFullYear()}/${toDouble(date.getMonth() + 1)}/${toDouble(
    date.getDate()
  )}/${parseInt(new Date().getTime() / 1000)}${Math.random()
    .toString(36)
    .substring(2)}${type}`;
}
// 弹窗
function toast(msg, duration) {
  duration = isNaN(duration) ? 3000 : duration;
  var m = document.createElement("div");
  m.innerHTML = msg;
  m.style.cssText =
    "max-width:80%;min-width: 150px;padding:14px  14px;min-height: 22px;color: rgb(255, 255, 255);line-height: 22px;text-align: center;border-radius: 4px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.8);font-size: 14px;";
  document.body.appendChild(m);
  setTimeout(function () {
    var d = 0.5;
    m.style.webkitTransition =
      "-webkit-transform " + d + "s ease-in, opacity " + d + "s ease-in";
    m.style.opacity = "0";
    setTimeout(function () {
      document.body.removeChild(m);
    }, d * 1000);
  }, duration);
}

//设置cookie
function setCookie(cname, cvalue, exday) {
  var d = new Date();
  d.setTime(d.getTime() + exday * 24 * 60 * 60 * 1000);
  var expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + "; " + expires + ";path=/";
  // document.cookie = cname + "=" + cvalue + "; " + expires;
}

// cookie
function getCookie(name) {
  var arr,
    reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

//清除cookie
function clearCookie(name) {
  setCookie(name, "", -7);
}

function isAndroid() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  if (isAndroid) {
    return true;
  } else if (isiOS) {
    return false;
  }
}

// 判断是否微信浏览器  授权登录
function isWeixin() {
  var ua = navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i) == "micromessenger") {
    return true;
  } else {
    return false;
  }
}

function toastShow(msg, status) {
  if (document.getElementsByClassName("toastShow").length > 0) {
    document.body.removeChild(document.getElementsByClassName("toastShow")[0]);
  }
  var m = document.createElement("div");
  m.className = "toastShow";
  m.innerHTML = msg;
  m.style.cssText =
    "max-width:80%;min-width: 150px;padding:14px 14px;min-height: 22px;color: rgb(255, 255, 255);line-height: 22px;text-align: center;border-radius: 4px;position: fixed;top: 50%;left: 50%;transform: translate(-50%, -50%);z-index: 999999;background: rgba(0, 0, 0,.8);font-size: 14px;";
  document.body.appendChild(m);
  if (!status) {
    var d = 0.5;
    m.style.webkitTransition =
      "-webkit-transform " + d + "s ease-in, opacity " + d + "s ease-in";
    m.style.opacity = "0";
    setTimeout(function () {
      document.body.removeChild(m);
    }, d * 1000);
  }
}

//获取随机字符串  e 表示长度，默认32位
function randomString(e) {
  e = e || 32;
  var t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678",
    a = t.length,
    n = "";
  for (let i = 0; i < e; i++) n += t.charAt(Math.floor(Math.random() * a));
  return n;
}
const localUrl = "https://m.ql1d.com/authority/shareFile/lists";
const localUrl1 = "https://m.ql1d.com/authority/shareFile/details/";

// 是9.5.3版本及之后的版本吗
function isVersion953(str) {
  // 第一位
  let numF = str.split(".")[0];
  // 中间位
  let numM = str.split(".")[1];
  // 最后位
  let numE = str.split(".")[2];
  if (numF < 9) {
    return false;
  }
  if (numF == 9) {
    if (numM < 5) {
      return false;
    }
    if (numM == 5) {
      if (numE >= 3) {
        return true;
      } else {
        return false;
      }
    }
    if (numM > 5) {
      return true;
    }
  }
  if (numF > 9) {
    return true;
  }
}

function formatData(value) {
  var date = new Date(value);
  var year = date.getFullYear(),
    month =
      date.getMonth() + 1 < 10
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1,
    day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate(),
    hour = date.getHours() < 10 ? "0" + date.getHours() : date.getHours(),
    min = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes(),
    sec = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  var newTime =
    year + "-" + month + "-" + day + " " + hour + ":" + min + ":" + sec;
  return newTime;
}

// cavas img
function cavasImg(url) {
  let imgDom = new Image();
  imgDom.setAttribute("crossOrigin", "Anonymous");
  imgDom.src = url;
  return imgDom;
}
// drawImage
function drawImage(ctx, dom, x, y, w, h) {
  ctx.drawImage(dom, x, y, w, h);
}
function drawCircleImage(ctx, img, x, y, radius) {
  ctx.save();
  let size = 2 * radius;
  ctx.arc(x, y, radius, 0, 2 * Math.PI);
  ctx.clip();
  ctx.drawImage(img, x - radius, y - radius, size, size);
  ctx.restore();
}
// cavas 普通文本
function customTxt(ctx, bolder, fs, color, txt, x, y) {
  ctx.fillStyle = color;
  ctx.font =
    "normal " +
    bolder +
    " " +
    fs +
    "px PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif";
  ctx.fillText(txt, x, y);
}
// cavas 画线
function line(ctx, pattern, color, blod, x0, y0, x1, y1) {
  ctx.beginPath();
  ctx.setLineDash(pattern);
  ctx.strokeStyle = color;
  ctx.lineWidth = blod;
  ctx.moveTo(x0, y0);
  ctx.lineTo(x1, y1);
  ctx.stroke();
}
//cavas 多行文本处理   居中，居左
function multiLineText(
  ctx,
  str,
  fs,
  color,
  bolder,
  txtWidth,
  offH,
  txtH,
  cavasW,
  txtX,
  from,
  line
) {
  ctx.fillStyle = color;
  ctx.font =
    "normal " +
    bolder +
    " " +
    fs +
    "px PingFang SC,Hiragino Sans GB,Microsoft YaHei,Arial,sans-serif";
  let lineWidth = 0;
  let canvasWidth = txtWidth; //计算canvas的宽度
  let initHeight = offH; //绘制字体距离canvas顶部初始的高度
  let lastW = 0;
  let lineNum = [0];
  for (let i = 0; i < str.length; i++) {
    lineWidth += ctx.measureText(str[i]).width;
    if (lineWidth > canvasWidth) {
      lineNum.push(i); //每一行开头
      lineWidth = 0;
    }
  }
  if (lineNum.length > line + 1) {
    //line+1行以上
    for (let n = 0; n < line; n++) {
      ctx.fillText(str.substring(lineNum[n], lineNum[n + 1]), txtX, initHeight);
      initHeight += txtH; //txtH为字体的高度
    }
    ctx.fillText(
      str.substring(lineNum[line], lineNum[line + 1] - 2) + "...",
      txtX,
      initHeight
    );
  } else {
    //line+1行及以下
    for (let n = 0; n < lineNum.length; n++) {
      if (n < line) {
        ctx.fillText(
          str.substring(lineNum[n], lineNum[n + 1]),
          txtX,
          initHeight
        );
        initHeight += txtH; //txtH为字体的高度
      } else {
        if (from == 1) {
          //居中
          for (let j = lineNum[lineNum.length - 1]; j < str.length; j++) {
            lastW += ctx.measureText(str[j]).width;
          }
          ctx.fillText(
            str.substring(lineNum[n], str.length),
            (cavasW - lastW) / 2,
            initHeight
          );
        } else {
          //左对齐
          ctx.fillText(str.substring(lineNum[n], str.length), txtX, initHeight); //绘制截取部分
        }
      }
    }
  }
}
function down(obj) {
  // 1普通新闻 2图集新闻 3视频新闻
  // 4专题 5 商品 6活动 8图文直播 10 视频直播11外链
  // 20意见反馈 30 VR新闻 31情报员申请通知
  // 13 记者 35音频 100智云推送 103 提问
  // 104 提问 101 报料详情页 102 报料详情页
  // 18 报料详情页 19 报料详情页
  // 9001  (9007公益活动详情)
  //===== 6 活动 11 外链 100 智云推送  这3个url得有值
  if (obj) {
    // eslint-disable-next-line no-undef
    MobLink(obj);
  } else {
    // eslint-disable-next-line no-undef
    MobLink([
      {
        el: "#openApp",
        path: "general/1",
        params: {
          newsid: "",
          type: "",
          url: "",
        },
      },
    ]);
  }
  // if(params.type){
  //     MobLink([
  //         {
  //             el: params.el,
  //             path: "general/1",
  //             params: {
  //                 newsid: params.newsid,
  //                 type: params.type,
  //                 url: params.url
  //             }
  //         }
  //     ])
  // }else{
  //     var u = navigator.userAgent;
  //     var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  //     var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
  //     if (isAndroid) {
  //         window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.com.qlwb.qiluyidian'
  //     } else if (isiOS) {
  //         window.location.href = 'https://itunes.apple.com/cn/app/qi-lu-yi-dian-ti-yu-gong-jiao/id903816468?mt=8'
  //     }
  //     if(!isMobile()){
  //         toast('请下载齐鲁壹点APP', 2000);
  //     }
  // }
}
//设备类型
function isMobile() {
  let ua = navigator.userAgent;
  return /(Android|webOS|iPhone|iPod|tablet|BlackBerry|Mobile)/i.test(ua)
    ? true
    : false;
}

function checkImgExists(imgurl) {
  return new Promise(function (resolve, reject) {
    var ImgObj = new Image();
    ImgObj.src = imgurl;
    ImgObj.onload = function (res) {
      resolve(res);
    };
    ImgObj.onerror = function (err) {
      reject(err);
    };
  });
}

function _isHarmonyOS() {
  let userAgent = navigator.userAgent || navigator.vendor || window.opera;
  return userAgent.toLowerCase().includes("openharmony");
}
export {
  getIsApp,
  toDouble,
  fileRandomKey,
  formatData,
  setCookie,
  getCookie,
  clearCookie,
  isAndroid,
  isWeixin,
  toast,
  toastShow,
  randomString,
  localUrl,
  localUrl1,
  isVersion953,
  cavasImg,
  drawCircleImage,
  drawImage,
  customTxt,
  line,
  multiLineText,
  isMobile,
  down,
  checkImgExists,
  _isHarmonyOS,
};
